import { createFrontendModule, microsoftAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => {
          const { SignInPage } = await import('@backstage/core-components');
          return props =>
            // eslint-disable-next-line new-cap
            SignInPage({
              ...props,
              provider: {
                id: 'microsoft-auth-provider',
                title: 'Microsoft',
                message: 'Sign in with your TomTom Microsoft account',
                apiRef: microsoftAuthApiRef,
              },
            });
        },
      },
    }),
  ],
});
